const COMPAT_MAX = 12;

export function initCompatibilityListTruncation() {
    let pdfLink = null;
    document.querySelectorAll('.itemcardMainDocuments .filegalleryFile').forEach(a => {
        if (a.textContent.trim().toLowerCase().includes('produktdatenblatt')) {
            pdfLink = a;
        }
    });

    document.querySelectorAll('.itemcardCompatibilityList').forEach(list => {
        const items = [...list.querySelectorAll('.itemcardCompatibilityItem')];
        if (items.length <= COMPAT_MAX) return;

        const hiddenItems = items.slice(COMPAT_MAX);
        hiddenItems.forEach(item => { item.hidden = true; });

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'itemcardCompatibilityItem itemcardCompatibilityItem--toggle';

        const setLabel = (expanded) => {
            toggle.textContent = expanded
                ? 'Weniger anzeigen'
                : `+ ${hiddenItems.length} weitere`;
            toggle.classList.toggle('is-expanded', expanded);
        };
        setLabel(false);

        toggle.addEventListener('click', () => {
            const expanded = !toggle.classList.contains('is-expanded');
            hiddenItems.forEach(item => { item.hidden = !expanded; });
            setLabel(expanded);
        });

        list.appendChild(toggle);

        if (!pdfLink) return;

        const more = document.createElement('a');
        more.href = pdfLink.href;
        more.target = '_blank';
        more.setAttribute('download', '');
        more.className = 'itemcardCompatibilityItem itemcardCompatibilityItem--more';
        more.textContent = 'Produktdatenblatt';
        list.appendChild(more);
    });
}

export function initResellerModalHeadlines() {
    const headlineEl = document.querySelector('.itemcardHeadline');
    if (!headlineEl) return;
    const headlineText = headlineEl.textContent.trim();

    document.querySelectorAll('.itemlistElement__description').forEach(desc => {
        const span = desc.querySelector('span');
        if (!span) return;
        const original = span.textContent.trim();
        span.textContent = `${headlineText} ${original}`;
    });
}